export default {
  name: { id: 'name' },
  edit: { id: 'edit' },
  jobs: { id: 'jobs' },
  title: { id: 'title' },
  save: { id: 'save_info' },
  select: { id: 'select' },
  value: { id: 'value' },
  image: { id: 'image' },
  option: { id: 'option' },
  description: { id: 'description' },
  instructions: { id: 'instructions' },
  jobInputsInfo: { id: 'job_workflow_inputs_info' },
  jobInputsList: { id: 'job_inputs_list' },
  jobInputGroupsList: { id: 'job_input_groups_list' },
  jobWorkflow: { id: 'job_workflow' },
  jobTaskWorkflow: { id: 'job_task_workflow' },
  inputType: { id: 'input_type' },
  required: { id: 'required' },
  position: { id: 'position' },
  parameters: { id: 'parameters' },
  active: { id: 'active' },
  dateUpdated: { id: 'date_updated' },
  dateCreated: { id: 'date_created' },
  editJobInput: { id: 'edit_job_input' },
  editJobInputGroup: { id: 'edit_job_input_group' },
  deleteJobInput: { id: 'delete_job_input' },
  deleteJobInputGroup: { id: 'delete_job_input_group' },
  createJobInput: { id: 'create_job_input' },
  createJobInputGroup: { id: 'create_job_input_group' },
  deleteJobInputMessage: { id: 'delete_job_input_message' },
  deleteJobInputGroupMessage: { id: 'delete_job_input_group_message' },
  workflowTitle: { id: 'workflow_title' },
  workflowTaskTitle: { id: 'workflow_task_title' },
  optionsSource: { id: 'options_source' },
  constantValue: { id: 'constant_value' },
  fileNotUploadMessage: { id: 'file_not_upload_message' },
  uploadPngJpeg: { id: 'upload_png_jpeg' },
  createButton: { id: 'create_button' },
  jobWorkflowList: { id: 'job_workflow_list' },
  createJobWorkflow: { id: 'create_licensee_application' },
  editJobWorkflow: { id: 'edit_licensee_application' },
  copyJobWorkflow: { id: 'copy' },
  emptyField: { id: 'invalid_empty_value' },
  removeItem: { id: 'remove_entry' },
  deleteJobWorkflow: { id: 'delete_licensee_application' },
  deleteJobWorkflowMessage: { id: 'delete_licensee_application_message' },
  copyJobWorkflowTitle: { id: 'copy_title' },
  copyJobWorkflowMessage: { id: 'copy_message' },
  paramsSelectHint: { id: 'parameters_select_error_message' },
  dynamicEntryHint: { id: 'dynamic_entries_error_message' },
  goToTasks: { id: 'go_to_tasks' },
  addDependency: { id: 'add_dependency' },
  shouldBe: { id: 'should_be' },
  then: { id: 'then' },
  duplicable: { id: 'duplicable' },
  jobInputGroupsInfo: { id: 'job_workflow_input_groups_info' },
  group: { id: 'group' },
  inputGroup: { id: 'input_group' },
  goToInputs: { id: 'go_to_inputs' },
  calculationInputPlaceholder: { id: 'calculation_input_placeholder' },
  inputs: { id: 'inputs' },
  outputs: { id: 'outputs' },
  calculated: { id: 'calculated' },
  canOnlyTakePictures: { id: 'can_only_take_pictures' },
  counter: { id: 'counter' },
  fromTable: { id: 'from_table' },
  fromColumn: { id: 'from_column' },
  onlyUnique: { id: 'only_unique' },
  addCondition: { id: 'add_condition' },
  addConditions: { id: 'add_conditions' },
  conditions: { id: 'conditions' },
  lookupInput: { id: 'lookup_input' },
  displayOnly: { id: 'display_only' },
  matchingValueIn: { id: 'matching_value_in' },
  simpleString: { id: 'simple_string' },
  lookupString: { id: 'lookup_string' },
  editable: { id: 'editable' },
  unchangeableTime: { id: 'unchangeable_time' },
  createsNewRowInTheTable: { id: 'creates_new_row_in_the_table' },
  display: { id: 'display' },
  update: { id: 'update_uppercase' },
  add: { id: 'add' },
  subtract: { id: 'subtract' },
  columnName: { id: 'column_name' },
  only: { id: 'only' },
  warning: { id: 'indicator_criticality_level_warning' },
  workflowSaveWarningMessage: { id: 'workflow_save_warning_message' },
  cancel: { id: 'cancel' },
  confirm: { id: 'confirm' },
  copyJobWorkflowToAnotherLicensee: {
    id: 'copy_job_workflow_to_another_licensee',
  },
  displayOptions: { id: 'display_options' },
  canSetCurrentDatetimeMessage: { id: 'can_set_current_datetime_message' },
  equalToSiteName: { id: 'equal_to_site_name' },
  equalToSiteNameTooltip: { id: 'equal_to_site_name_tooltip' },
  useWorkerSignatureTemplate: { id: 'use_worker_signature_template' },
  negativeValidationCheckbox: { id: 'negative_validation_checkbox' },
}
